<template lang="html">
	<div class="about-modules">
		<div class="row justify-content-center">
			<div class="col-12 col-lg-11 col-xl-10">
				<h2>Modules</h2>
				<div class="row">
					<div class="row">
						<div
							class="col-12 col-md-6 col-lg-4 article"
							v-for="(article, index) in articles"
							:key="index"
						>
							<div class="image-box">
								<div
									class="image"
									:style="`background: url(${article.image}) no-repeat`"
								></div>
								<div class="overlay">
									<div class="module-desc">
										<div class="icon">
											<i :class="article.icon"></i>
										</div>
										<div class="m-title">
											{{ article.title }}
										</div>
									</div>
								</div>
							</div>
							<div class="content-box">
								<div class="dates clearfix">
									<div class="num f-l">
										{{ article.uploader }}
									</div>
									<div class="dot f-l"></div>
									<div class="updated f-l">
										Last Updated {{ article.date }}
									</div>
								</div>
								<div class="desc">{{ article.desc }}</div>

								<div
									class="clearfix btn-close"
									@click="
										$router.push({
											name: 'ViewBlog',
											params: {
												id: Math.round(
													Math.random() * 1000,
												),
											},
										})
									"
								>
									<div class="text f-l">Read More</div>
									<div class="fa fa-chevron-right f-l"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	computed: {
		...mapGetters(['articles', 'loading']),
	},
	methods: {
		...mapActions(['sendMessage']),
	},
	mounted() {},
};
</script>

<style lang="less">
.about-modules {
	background-color: var(--white);
	padding: 30px 0 70px 0;

	h3 {
		font-size: 20px;
		opacity: 0.4;
	}
	h2 {
		font-size: 24px;
		text-align: center;
		margin: 10px 0 50px 0;
		color: #6b6f81;
	}
	.txt-link {
		float: right;
		font-size: 13px;
		font-family: var(--font-bold);
		color: #1761fa;
	}

	.article {
		cursor: pointer;
		border-radius: 5px 5px 0 0;

		.btn-close {
			color: #1761fa;
			cursor: pointer;
			margin: 80px 0 15px 0;

			.fa {
				width: 30px;
				height: 30px;
				border-radius: 50px;
				font-size: 16px;
				border: solid 2px #1761fa;
				text-align: center;
				padding: 5px 0;
			}
			.text {
				margin: 4px 20px 0 0;
				font-size: 14px;
				font-weight: 600;
			}

			&:hover {
				.text {
					text-decoration: underline;
				}
			}
		}
		.image-box {
			background: #f9f9f9;
			border-radius: 5px 5px 0 0;
			height: 200px;
			width: 100%;
			overflow: hidden;
			position: relative;

			.image {
				height: 270px;
				background-size: cover !important;
				background-position: center !important;
				border-radius: 5px 5px 0 0;
				transition: all 1s;
			}

			.overlay {
				position: absolute;
				background: rgba(0, 31, 95, 0.4);
				color: var(--white);
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				text-align: center;
				padding: 60px 0 0 0;

				.icon {
					font-size: 24px;
				}
				.m-title {
					font-weight: 600;
					margin: 5px 0 0 0;
				}
			}
		}
		.content-box {
			background: var(--white);
			padding: 10px 15px 15px 15px;
			border-radius: 0;
			border-bottom: solid 1px #5458e1;

			.small-title {
				opacity: 0.6;
				letter-spacing: 0.9px;
				color: #737686;
				font-weight: 600;
				text-transform: uppercase;
			}
			.desc {
				color: #6b6f81;
				font-weight: 600;
			}
			.dates {
				color: #737686;
				opacity: 0.6;
				font-size: 14px;
				font-weight: 600;
				margin: 5px 0 30px 0;

				.dot {
					width: 4px;
					height: 4px;
					border-radius: 50%;
					opacity: 0.6;
					background: #737686;
					margin: 8px 15px;
				}
			}
		}

		&:hover {
			.image {
				transform: scale(1.2);
			}
		}
	}
}
</style>
